/* eslint-disable no-open-modules-imports */

import type { FeatureGroup } from 'feature/feature-helpers';
import { CHOOSEONE, COMPOSITE, SECTION } from 'feature/feature-helpers';
import { EditorialQuestionFeature, GreenQuestionTeaserFeature, TanQuestionTeaserFeature } from 'feature/teaser/editorial-question';
import { EmbeddedQuestionTeaserFeature } from 'feature/teaser/embedded-question-teaser';
import { AskMeAnythingTeaserFeature, TopicTeaserFeature } from 'open-modules/cbcrc/feature/connect/topic-teaser';
import { DialogueGreenQuestionTeaserFeature, DialogueTanQuestionTeaserFeature } from 'open-modules/srg/feature/teaser/dialog-teaser';
import { TeaserPositionFeature } from 'open-modules/zdf/feature/article/article-teaser-position';
import { OnlyAdminButtonTeaserFeature } from 'open-modules/zdf/feature/teaser/only-admin-teaser';
import { VideoVotingFeature, VideoVotingVideoOverlayFeature } from 'open-modules/zdf/feature/videovoting/video-voting-article';
import { t } from 'util/stdtypes';

export const articleFeatures: FeatureGroup[] = [
    COMPOSITE(EditorialQuestionFeature, [
        CHOOSEONE(t('Teaser Type'), [
            GreenQuestionTeaserFeature,
            TanQuestionTeaserFeature,
            AskMeAnythingTeaserFeature,
            TopicTeaserFeature,
            DialogueGreenQuestionTeaserFeature,
            DialogueTanQuestionTeaserFeature,
            EmbeddedQuestionTeaserFeature,
        ]),
    ]),
    // EditorialQuestionFeature,
    COMPOSITE(VideoVotingFeature, [VideoVotingVideoOverlayFeature]),
    SECTION(t('Admin only teaser'), [OnlyAdminButtonTeaserFeature]),
    SECTION(t('ZDF'), [TeaserPositionFeature]),
];

export const articleDefaultConfig = {
    editorialquestion: true,
    videovotingArticle: false,
    videovotingArticleTextIntegration: false,
};
